// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3smEo","col":"styles_col__1uwy6"};